import { MultimediaStatus } from "./multimedia-status";

export enum DeviceStatus {
  Offline = "offline",

  Ready = "ready",

  Busy = "busy",

  Loading = "loading",
}

export interface DeviceShadow {
  status?: DeviceStatus;

  device?: DeviceShadowDevice;

  display?: any;

  multimedia?: MultimediaStatus;
}

export interface DeviceShadowDevice {
  id: string;

  version: DeviceShadowDeviceVersion;
}

export interface DeviceShadowDeviceVersion {
  application: string;

  system: string;
}
